var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t.__(
              "dashboard.forms.LastObjectSettingForm.select_objects_to_display"
            ),
            prop: "objects"
          }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-4",
              attrs: { multiple: "" },
              model: {
                value: _vm.form.objects,
                callback: function($$v) {
                  _vm.$set(_vm.form, "objects", $$v)
                },
                expression: "form.objects"
              }
            },
            _vm._l(_vm.objectsList, function(object) {
              return _c("el-option", {
                key: object.value,
                attrs: { label: object.label, value: object.value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright mt-5" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submitForm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }